<div class="toggle-switch" (click)="toggleSwitch()" [ngClass]="{active: value}">
  <div class="indicator"></div>
</div>
